import { render, staticRenderFns } from "./FreeWordItemForm.vue?vue&type=template&id=625c30de&scoped=true&"
import script from "./FreeWordItemForm.vue?vue&type=script&lang=ts&"
export * from "./FreeWordItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./FreeWordItemForm.vue?vue&type=style&index=0&id=625c30de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c30de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VSimpleTable,VTextField})
